import {
  Skeleton,
  usePriceInfoVariants,
  useProductViewSkeletonVariants,
} from '@/modules/Frontend/Theme'

import { PriceLines } from './PriceLines'
import { findCustomAttributeValue } from '../../../lib'
import { getPriceSummary, parseMsrp } from '../../../lib/pricing'
import { useProductAttributes } from '../../../state'

function PriceInfoSkeleton() {
  const { skeletonSectionVariants } = useProductViewSkeletonVariants()

  return (
    <div className={skeletonSectionVariants({ section: 'priceInfo' })}>
      <Skeleton size="sm" width="half" className="mb-3 xl:mb-5" />
      <Skeleton size="xl" width="half" className="mb-3 xl:mb-5" />
    </div>
  )
}

export function PriceInfo() {
  const { productAttributes, customAttributes, loading } = useProductAttributes()
  const { priceInfoWrapperVariants } = usePriceInfoVariants()

  if (loading) return <PriceInfoSkeleton />

  if (!productAttributes) return null

  return (
    <div className={priceInfoWrapperVariants()}>
      <PriceLines
        price={getPriceSummary(productAttributes.price_range?.minimum_price)}
        msrp={parseMsrp(findCustomAttributeValue(customAttributes, 'msrp'))}
      />
    </div>
  )
}
